import { PREVIEW_TYPES } from '@wix/wix-vod-constants/common';
export const hasTrailer = (videoItem) => Boolean(videoItem.trailerFileName);
export const getPreviewType = (videoItem) => videoItem.previewType || PREVIEW_TYPES.FIRST_20_SEC;
export const isPreviewEnabled = (videoItem) => videoItem.previewType !== PREVIEW_TYPES.NONE;
export const isTrailerPreviewTypeEnabled = (videoItem) => videoItem.previewType === PREVIEW_TYPES.TRAILER;
//# sourceMappingURL=preview.js.map